import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useRef, cloneElement, createElement } from 'react';
import '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import { cleanChildren } from '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import { useId } from '@reach/auto-id';
import ButtonGroup from '../ButtonGroup/index.esm.js';

function RadioButtonGroup(props) {
  var name = props.name,
      children = props.children,
      defaultValue = props.defaultValue,
      controlledValue = props.value,
      fullWidth = props.fullWidth,
      _props$display = props.display,
      display = _props$display === void 0 ? fullWidth ? 'flex' : 'inline-flex' : _props$display,
      spacing = props.spacing,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? false : _props$inline,
      onChange = props.onChange,
      rest = _objectWithoutPropertiesLoose(props, ["name", "children", "defaultValue", "value", "fullWidth", "display", "spacing", "inline", "onChange"]);

  var isControlled = controlledValue != null;

  var _React$useState = useState(defaultValue || null),
      value = _React$useState[0],
      setValue = _React$useState[1];

  var innerValue = isControlled ? controlledValue : value;
  var allNodes = useRef([]);
  var validChildren = cleanChildren(children);
  var focusableValues = validChildren.map(function (child) {
    return child.props.isDisabled === true ? null : child.props.value;
  }).filter(function (val) {
    return val != null;
  });
  var allValues = validChildren.map(function (child) {
    return child.props.value;
  });

  var updateIndex = function updateIndex(index) {
    var _allNodes$current$inn;

    var childValue = focusableValues[index];
    var innerIndex = allValues.indexOf(childValue);
    allNodes == null ? void 0 : (_allNodes$current$inn = allNodes.current[innerIndex]) == null ? void 0 : _allNodes$current$inn.focus();

    if (!isControlled) {
      setValue(childValue);
    }

    if (onChange) {
      onChange(childValue);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Tab') {
      return;
    } // Disable page scrolling while navigating with keys


    event.preventDefault();
    var count = focusableValues.length;
    var enabledCheckedIndex = focusableValues.indexOf(innerValue);

    if (enabledCheckedIndex === -1) {
      enabledCheckedIndex = 0;
    }

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        {
          var nextIndex = (enabledCheckedIndex + 1) % count;
          updateIndex(nextIndex);
          break;
        }

      case 'ArrowLeft':
      case 'ArrowUp':
        {
          var _nextIndex = (enabledCheckedIndex - 1 + count) % count;

          updateIndex(_nextIndex);
          break;
        }
    }
  };

  var fallbackName = "radio-" + useId();
  var innerName = name || fallbackName;
  var clones = validChildren.map(function (child, index) {
    var isFirstChild = index === 0;
    var checked = child.props.value === innerValue;

    var handleClick = function handleClick() {
      if (!isControlled) {
        setValue(child.props.value);
      }

      if (onChange) {
        onChange(child.props.value);
      }
    };

    var getTabIndex = function getTabIndex() {
      // If a RadioGroup has no radio selected the first enabled radio should be focusable
      if (innerValue == null) {
        return isFirstChild ? 0 : -1;
      }

      return checked ? 0 : -1;
    };

    return cloneElement(child, {
      // eslint-disable-next-line react/no-array-index-key
      key: index,
      ref: function ref(node) {
        allNodes.current[index] = node;
        return node;
      },
      name: innerName,
      onClick: handleClick,
      tabIndex: getTabIndex(),
      checked: checked
    });
  });
  return createElement(ButtonGroup, _extends({}, rest, {
    display: display,
    fullWidth: fullWidth,
    inline: inline,
    space: spacing,
    role: "radiogroup",
    onKeyDown: handleKeyDown
  }), clones);
}

RadioButtonGroup.displayName = 'RadioButtonGroup';

export default RadioButtonGroup;
//# sourceMappingURL=index.esm.js.map
